
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "payments-ui-app",
  currentProjectVersion: "static-1.28949",
  depVersions: {
  "payments-ui-app": "static-1.28949",
  "apollo-dlb": "static-3.98",
  "bend-plugin-arboretum": "static-1.2096",
  "client-types": "static-1.524",
  "crm_data": "static-4.93374",
  "data-fetching-client": "static-1.10178",
  "emoji-mart": "static-3.10",
  "enviro": "static-4.529",
  "foundations-components": "static-1.8858",
  "foundations-components-legacy": "static-1.1883",
  "head-dlb": "static-1.5344",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.6133",
  "hs-test-utils": "static-1.8585",
  "hub-http": "static-1.6745",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.12033",
  "I18n": "static-7.1727",
  "jasmine-runner": "static-1.7002",
  "quartz": "static-1.7773",
  "raven": "static-3.6435",
  "react-dlb": "static-1.97",
  "react-stripe-js": "static-1.124",
  "react-utils": "static-2.5721",
  "reselect": "static-3.20",
  "stripe-js": "static-1.123",
  "ui-components-test-utils": "static-1.6170",
  "UIComponents": "static-3.8979",
  "usage-tracker-public": "static-1.7700",
  "apollo-stack-hubspot": "static-3.94",
  "commerce-subscription-lib": "static-1.38182",
  "cssUtils": "static-1.1163",
  "customer-data-objects": "static-1.8258",
  "FireAlarmUi": "static-1.4931",
  "foundations-assets": "static-1.5432",
  "foundations-theming": "static-1.5046",
  "graphql": "static-1.96",
  "hs-browser-apis": "static-1.18",
  "hubspot-url-utils": "static-1.4383",
  "HubStyle": "static-2.12340",
  "icons": "static-2.719",
  "isMobile": "static-1.7",
  "metrics-js": "static-1.9990",
  "PatternValidationJS": "static-1.3419",
  "payments-checkout-lib": "static-1.872",
  "property-translator": "static-1.5918",
  "quartz-config": "static-1.1551",
  "quartz-core": "static-1.6992",
  "quartz-i18n": "static-1.1448",
  "quartz-routing": "static-1.1203",
  "quartz-tracking": "static-1.1152",
  "react": "static-7.206",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1-fkhalid-web-vitals-route-attribution.6",
  "react-select-plus": "static-1.121",
  "react-virtualized": "static-2.115",
  "redux": "static-4.81",
  "redux-thunk": "static-2.88",
  "redux-toolkit": "static-1.85",
  "ReduxMessenger": "static-2.10915",
  "rpc-client-utils": "static-1.5209",
  "sanitize-text": "static-1.8700",
  "SharedI18nStrings": "static-1.191",
  "styled-components": "static-2.100",
  "StyleGuideUI": "static-3.523",
  "superstore": "static-1.5298",
  "transmute": "static-2.97",
  "ui-addon-i18n": "static-1.11691",
  "ui-images": "static-2.1299",
  "usage-tracker-core": "static-1.7739",
  "hs-promise-rejection-tracking": "static-1.6102",
  "PortalIdParser": "static-2.459",
  "raven-hubspot": "static-1.6742",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.4050",
  "quartz-webpack": "static-1.3997",
  "bend-plugin-quartz-routing": "static-1.851",
  "bender-build-tools": "static-1.3654",
  "crm_universal": "static-1.22817",
  "customer-data-email": "static-1.18744",
  "customer-data-ui-utilities": "static-1.10376",
  "dispatcher": "static-1.151",
  "frontend-preferences-client": "static-1.8466",
  "general-store": "static-6.20",
  "native-integrations-shared-strings": "static-1.8301",
  "quick-fetch": "static-1.4270",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.5127",
  "floating-ui": "static-1.71",
  "foundations-theming-specialty": "static-1.2762",
  "framer-motion": "static-1.87",
  "hs-story-utils": "static-1.9967",
  "react-aria": "static-1.80",
  "react-create-root-preference": "static-1.125",
  "tanstack-table": "static-1.69",
  "trellis-assets": "static-1.3277",
  "ui-fonts": "static-1.1295",
  "HeadJS": "static-2.839",
  "hs-test-utils-bend-plugin": "static-1.3696",
  "msw": "static-1.106",
  "msw-config": "static-1.46",
  "testing-library": "static-1.168",
  "hs-locale-management": "static-1.446",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.238",
  "moment-timezone": "static-5.99",
  "jasmine": "static-4.4848",
  "foundations-components-test-utils": "static-1.6341",
  "ui-addon-draggable": "static-3.5295",
  "commerce-billing-lib": "static-1.20640",
  "commerce-shared-components-lib": "static-1.19710",
  "commerce-tools-ui-lib": "static-1.11442",
  "crm-message-bus": "static-1.44272",
  "customer-data-objects-ui-components": "static-1.13580",
  "customer-data-properties": "static-1.53272",
  "growth-payments-core": "static-1.26641",
  "ui-addon-iframeable": "static-1.9622",
  "usage-tracker": "static-1.7889",
  "usage-tracker-container": "static-1.7879",
  "sassPrefix": "static-1.430",
  "inbound-db-properties-service-client": "static-1.4193",
  "foundations-theming-base": "static-1.4031",
  "bend-plugin-foundations-theming": "static-1.3529",
  "stylex": "static-1.50",
  "opentelemetry-fe-types": "static-1.343",
  "hub-http-janus": "static-1.923",
  "hubspotter-http": "static-1.5013",
  "mobile-manifest-mixins": "static-1.623",
  "module-federation": "static-1.42",
  "opentelemetry-fe": "static-1.718",
  "quartz-auth": "static-1.1448",
  "quartz-head": "static-1.1438",
  "quartz-test": "static-1.1448",
  "trellis-components": "static-1.3296",
  "usage-tracker-session-replay": "static-1.5575",
  "csstype": "static-1.50",
  "beacon-keepalive-queue": "static-1.245",
  "web-vitals": "static-1.22",
  "immer": "static-1.107",
  "bend-plugin-chirp-manifest": "static-1.619",
  "chirp-fetch": "static-1.2443",
  "autolinker": "static-3.11",
  "sanitize": "static-1.5011",
  "FormUrlGenerator": "static-2.5254",
  "sequences-lib": "static-1.8879",
  "apollo-link-hub-http": "static-2.5132",
  "FileManagerCore": "static-1.40447",
  "FileManagerLib": "static-1.40588",
  "hubspot-apollo-client": "static-1.5419",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "salesImages": "static-1.801",
  "timezone-utils": "static-2.5769",
  "ui-gdpr-components": "static-1.10659",
  "react-dnd-compat": "static-1.5153",
  "stylex-utils": "static-1.194",
  "trellis-theming": "static-1.1588",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.86",
  "avatar-components": "static-1.3031",
  "crm-command-handler-types": "static-1.210",
  "hs-resources": "static-1.739",
  "onboarding-scopes": "static-1.6995",
  "pulse": "static-1.1215",
  "upgrade-components-lib": "static-1.802",
  "utility-belt": "static-1.3078",
  "zustand": "static-1.93",
  "batch-promise": "static-1.2094",
  "customer-data-associations": "static-1.7887",
  "customer-data-property-utils": "static-1.8602",
  "customer-data-tracking": "static-1.7413",
  "framework-data-table": "static-2.12956",
  "object-builder-ui-client": "static-1.50239",
  "payments-enrollment-embed-lib": "static-1.24417",
  "stripe-embedded-components": "static-1.8341",
  "ui-addon-opt": "static-4.8982",
  "ai-components-ui-library": "static-1.10143",
  "customer-data-rte": "static-1.34010",
  "cv-backend-services": "static-1.1622",
  "file-manager-components": "static-1.24948",
  "growth-onboarding-confetti": "static-1.3600",
  "growth-onboarding-empty-states": "static-1.6636",
  "hubspot-prosemirror": "static-1.19415",
  "InboxConnectUtils": "static-4.15969",
  "payment-link-components": "static-1.24600",
  "payments-post-enroll-local-storage-lib": "static-1.5641",
  "prosemirror": "static-1.13",
  "qrcode-generator": "static-1.83",
  "quotes-client-types": "static-1.39305",
  "react-colorpicker": "static-2.10753",
  "ui-addon-upgrades": "static-9.18615",
  "ui-addon-video-player": "static-1.9165",
  "user-context": "static-1.5598",
  "atom": "static-1.5616",
  "reference-resolvers": "static-1.8729",
  "calling-global-api": "static-1.66542",
  "calling-internal-common": "static-1.31866",
  "calling-lifecycle-internal": "static-1.67924",
  "calling-lifecycle-messages": "static-1.60216",
  "commerce-products-lib": "static-1.11112",
  "conditional-properties-service-client": "static-1.4154",
  "crm-index-visualization-core": "static-1.4855",
  "crm-links": "static-1.6870",
  "crm-pipelines-api-client-types": "static-1.4487",
  "customer-data-properties-shared-msw-handlers": "static-1.10341",
  "data-agent-utils": "static-1.1076",
  "data-token-picker": "static-1.17232",
  "external-options-client-types": "static-1.4478",
  "formula-editor": "static-1.15090",
  "google-libphonenumber": "static-1.53",
  "inbound-db-meta-service-client": "static-1.3813",
  "inbounddb-objects-service-types": "static-1.4557",
  "meetings-icalendar-utils-lib": "static-1.1178",
  "multi-currency-client-types": "static-1.4052",
  "pipeline-validation-client-types": "static-1.4325",
  "property-value-citations": "static-1.3886",
  "react-tinymce": "static-1.56387",
  "reference-resolvers-lite": "static-1.8656",
  "rich-text-lib": "static-1.20655",
  "smart-data-capture-core": "static-1.624",
  "tiered-pricing": "static-1.2394",
  "tinymce-config": "static-2.55513",
  "tinymce-plugins": "static-1.58627",
  "tinymce-themes": "static-1.57483",
  "topics-actions-lib": "static-1.736",
  "trellis-ext-i18n": "static-1.1488",
  "trial-components-library": "static-1.14492",
  "ui-addon-emoji-picker": "static-1.10408",
  "ui-addon-form-validation": "static-1.11356",
  "laboratory-lib": "static-3.7692",
  "seat-types-lib": "static-1.1186",
  "magpie-lib": "static-1.5966",
  "navigation-messaging": "static-1.8667",
  "ts-schema": "static-1.4437",
  "opentelemetry-web": "static-1.26",
  "hub-http-shared-msw-handlers": "static-1.11014",
  "hubspotter-http-shared-msw-handlers": "static-1.11012",
  "base-ui": "static-1.32",
  "react-day-picker": "static-1.19",
  "tanstack-virtual": "static-1.46",
  "amplitude-session-replay-browser": "static-1.80",
  "sequences-client-types-lib": "static-1.8736",
  "audio-components": "static-1.6660",
  "breeze-artifacts-sdk": "static-1.1234",
  "ContentUtils": "static-1.69631",
  "copilot-toolkit": "static-1.12279",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.30157",
  "FileManagerImages": "static-1.38099",
  "html-to-image": "static-1.70",
  "immerable": "static-1.4687",
  "ui-universal-auth": "static-1.9874",
  "urlinator": "static-1.5060",
  "video-components": "static-1.14568",
  "video-data-lib": "static-1.36224",
  "video-embed": "static-1.37058",
  "hubspot-apollo-cache": "static-1.878",
  "trellis-migration-context": "static-1.121",
  "event-emitter": "static-1.1500",
  "fdsr-migration-layer": "static-1.557",
  "framework-builder-read-service-client": "static-1.4374",
  "bend-plugin-pulse": "static-1.718",
  "fast-json-patch": "static-1.79",
  "merchandise-lib": "static-1.291",
  "purchase-motions-components": "static-1.6727",
  "customer-data-reference-ui-components": "static-1.13720",
  "reporting-data": "static-1.69661",
  "tasks-actions-lib": "static-1.575",
  "growth-onboarding-feedback-components": "static-1.7128",
  "growth-onboarding-reliability": "static-1.5626",
  "marketplace-ui-apps-core": "static-1.19702",
  "onboarding-tours": "static-1.17491",
  "stripe-connect-js": "static-1.86",
  "chatspot-core": "static-1.24317",
  "content-assistance-lib": "static-1.8511",
  "draft-content-plugins": "static-1.29263",
  "draft-convert": "static-2.88",
  "draft-extend": "static-3.91",
  "draft-js": "static-5.93",
  "draft-plugins": "static-2.22460",
  "breeze-engine-lib": "static-1.2405",
  "poll-commands": "static-1.4018",
  "video-components-external": "static-1.12566",
  "trellis-story-utils": "static-1.5039",
  "ui-addon-react-router-dom": "static-1.10072",
  "content-media-capture": "static-1.5900",
  "knowledge-content-types": "static-1.8767",
  "ui-business-units-lib": "static-1.9640",
  "ui-shepherd-react": "static-3.10830",
  "hub-http-contrib": "static-1.3573",
  "ui-addon-sales-email": "static-1.5750",
  "commerce-tours-lib": "static-1.6957",
  "getting-started-shared-tasks": "static-1.19676",
  "sales-checkout-service-client": "static-1.4062",
  "getting-started-shared-tasks-store": "static-1.18794",
  "onboarding-tours-utils": "static-1.1558",
  "calling-error-reporting": "static-1.31873",
  "shared-worker-versioning": "static-1.11583",
  "calling-usage-tracker": "static-1.7084",
  "conversations-skeleton-state": "static-1.7657",
  "voice-sms-access-library": "static-1.2626",
  "commerce-permissions": "static-1.1323",
  "products-iframe-lib": "static-1.9068",
  "products-ui-components-shared-msw-handlers": "static-1.11396",
  "crm-index-associations-lib": "static-1.6993",
  "sales-views-client-types": "static-1.4801",
  "location-customization-utils-lib": "static-1.10565",
  "data-agent-kit": "static-1.1063",
  "enrichment-settings-lib": "static-1.423",
  "fsm": "static-1.4304",
  "markdown-it": "static-1.6",
  "policy-lib": "static-1.7344",
  "bark-lib": "static-1.17077",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.109",
  "crm-properties-common-lib": "static-1.6440",
  "react-codemirror": "static-1.11184",
  "tinymce": "static-5.11",
  "interframe": "static-3.5288",
  "tinymce-data": "static-1.41598",
  "layout-dnd-components": "static-1.13328",
  "layout-dnd-utils": "static-1.12303",
  "ui-brand-identity-lib": "static-1.17112",
  "NamespacedHubStyle": "static-2.9411",
  "embedded-academy-lib": "static-1.16243",
  "hubs-service-types": "static-1.1809",
  "navigation-components": "static-1.19340",
  "nest": "static-1.782",
  "nudge-client-utils": "static-1.3520",
  "purchase-motions-api": "static-1.6730",
  "signup-constants": "static-1.20127",
  "idb-keyval": "static-1.59",
  "magpie-types": "static-1.5426",
  "reactive-lib": "static-1.1265",
  "simple-logging-lib": "static-1.3590",
  "nav-meta": "static-1.30977",
  "breeze-engine-core": "static-1.1683",
  "cms-field-types": "static-1.5356",
  "content-icons-ui": "static-1.2526",
  "integrations-lib": "static-1.17574",
  "underscore": "static-1.8",
  "custom-vendor-connection-lib": "static-1.438",
  "unified-auth-core-lib": "static-1.1670",
  "social-insights-client-types": "static-1.23057",
  "outpost": "static-1.4668",
  "persist-promise": "static-1.4251",
  "signup-ui-url-generator": "static-2.8578",
  "reporting-client-types": "static-1.2905",
  "developer-experience-shared-components": "static-1.11089",
  "immutable-less": "static-1.5191",
  "marketplace-ui-client-types": "static-1.18577",
  "marketplace-ui-common": "static-1.21170",
  "ui-addon-integrations-directory-panel": "static-2.8492",
  "ui-extensibility-client-types": "static-1.4461",
  "growth-data-modal": "static-1.6226",
  "growth-onboarding-next-action-utils": "static-1.3113",
  "onboarding-tours-client": "static-1.5706",
  "ui-shepherd-tracker": "static-1.8211",
  "ui-coaching-tips": "static-1.29646",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1383",
  "highlight.js": "static-1.93",
  "content-media-composition-data-lib": "static-1.13704",
  "content-media-compositions": "static-2.17711",
  "media-bridge-lib": "static-1.19738",
  "fix-webm-duration": "static-1.38",
  "notification-sounds": "static-1.4972",
  "calling-orchestration-schema": "static-1.37403",
  "crm-record-cards-service-types": "static-1.3897",
  "highcharts": "static-8.118",
  "storybook-react": "static-1.47",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16786",
  "browser-eslint": "static-2.57",
  "ContentData": "static-1.69706",
  "layout-data-lib": "static-1.10628",
  "academy-common-lib": "static-1.15704",
  "nudge-custom-function-registry": "static-1.3277",
  "nudge-renderer-utils": "static-1.3596",
  "whisper-core-api": "static-1.7753",
  "flux-actions": "static-1.384",
  "integrations-error-boundary-lib": "static-1.14989",
  "integrations-tracking-lib": "static-1.6171",
  "redux-observable": "static-1.82",
  "rxjs": "static-5.10",
  "apps-service-types": "static-1.4151",
  "oauth-service-types": "static-1.4679",
  "ai-settings-ui-library": "static-1.8694",
  "react-window": "static-1.13",
  "ui-product-approvals-common": "static-1.1827",
  "onboarding-data-sync-lib": "static-1.2930",
  "growth-onboarding-next-action-components": "static-1.3141",
  "user-context-client": "static-1.5051",
  "js-cookie": "static-1.18",
  "advanced-menus-core": "static-1.15917",
  "advanced-menus-lib": "static-1.12644",
  "ExportDialog": "static-6.10915",
  "ui-memberships-settings-lib": "static-1.35343",
  "academy-service-client": "static-1.4236",
  "croppie": "static-2.10",
  "final-form": "static-1.86",
  "SafeStorage": "static-1.4938",
  "trellis-ecosystem": "static-1.7947",
  "universal-page-editor-lib": "static-1.3563",
  "settings-ui-lib": "static-1.13076",
  "simple-data-table": "static-1.3952",
  "meetings-connect-utils-lib": "static-1.8162",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15916",
  "simple-menus-lib": "static-1.17433",
  "crm-record-cards-client": "static-1.246",
  "framework-data-schema-resolvers": "static-1.7432",
  "framework-data-schema-quick-fetch": "static-1.7337"
},
  depPathPrefixes: {
  "payments-ui-app": "/payments-ui-app/static-1.28949",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "bend-plugin-arboretum": "/bend-plugin-arboretum/static-1.2096",
  "client-types": "/client-types/static-1.524",
  "crm_data": "/crm_data/static-4.93374",
  "data-fetching-client": "/data-fetching-client/static-1.10178",
  "emoji-mart": "/emoji-mart/static-3.10",
  "enviro": "/enviro/static-4.529",
  "foundations-components": "/foundations-components/static-1.8858",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1883",
  "head-dlb": "/head-dlb/static-1.5344",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.6133",
  "hs-test-utils": "/hs-test-utils/static-1.8585",
  "hub-http": "/hub-http/static-1.6745",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.12033",
  "I18n": "/I18n/static-7.1727",
  "jasmine-runner": "/jasmine-runner/static-1.7002",
  "quartz": "/quartz/static-1.7773",
  "raven": "/raven/static-3.6435",
  "react-dlb": "/react-dlb/static-1.97",
  "react-stripe-js": "/react-stripe-js/static-1.124",
  "react-utils": "/react-utils/static-2.5721",
  "reselect": "/reselect/static-3.20",
  "stripe-js": "/stripe-js/static-1.123",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.6170",
  "UIComponents": "/UIComponents/static-3.8979",
  "usage-tracker-public": "/usage-tracker-public/static-1.7700",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.38182",
  "cssUtils": "/cssUtils/static-1.1163",
  "customer-data-objects": "/customer-data-objects/static-1.8258",
  "FireAlarmUi": "/FireAlarmUi/static-1.4931",
  "foundations-assets": "/foundations-assets/static-1.5432",
  "foundations-theming": "/foundations-theming/static-1.5046",
  "graphql": "/graphql/static-1.96",
  "hs-browser-apis": "/hs-browser-apis/static-1.18",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyle": "/HubStyle/static-2.12340",
  "icons": "/icons/static-2.719",
  "isMobile": "/isMobile/static-1.7",
  "metrics-js": "/metrics-js/static-1.9990",
  "PatternValidationJS": "/PatternValidationJS/static-1.3419",
  "payments-checkout-lib": "/payments-checkout-lib/static-1.872",
  "property-translator": "/property-translator/static-1.5918",
  "quartz-config": "/quartz-config/static-1.1551",
  "quartz-core": "/quartz-core/static-1.6992",
  "quartz-i18n": "/quartz-i18n/static-1.1448",
  "quartz-routing": "/quartz-routing/static-1.1203",
  "quartz-tracking": "/quartz-tracking/static-1.1152",
  "react": "/react/static-7.206",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1-fkhalid-web-vitals-route-attribution.6",
  "react-select-plus": "/react-select-plus/static-1.121",
  "react-virtualized": "/react-virtualized/static-2.115",
  "redux": "/redux/static-4.81",
  "redux-thunk": "/redux-thunk/static-2.88",
  "redux-toolkit": "/redux-toolkit/static-1.85",
  "ReduxMessenger": "/ReduxMessenger/static-2.10915",
  "rpc-client-utils": "/rpc-client-utils/static-1.5209",
  "sanitize-text": "/sanitize-text/static-1.8700",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.191",
  "styled-components": "/styled-components/static-2.100",
  "StyleGuideUI": "/StyleGuideUI/static-3.523",
  "superstore": "/superstore/static-1.5298",
  "transmute": "/transmute/static-2.97",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11691",
  "ui-images": "/ui-images/static-2.1299",
  "usage-tracker-core": "/usage-tracker-core/static-1.7739",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.6102",
  "PortalIdParser": "/PortalIdParser/static-2.459",
  "raven-hubspot": "/raven-hubspot/static-1.6742",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.4050",
  "quartz-webpack": "/quartz-webpack/static-1.3997",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.851",
  "bender-build-tools": "/bender-build-tools/static-1.3654",
  "crm_universal": "/crm_universal/static-1.22817",
  "customer-data-email": "/customer-data-email/static-1.18744",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10376",
  "dispatcher": "/dispatcher/static-1.151",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8466",
  "general-store": "/general-store/static-6.20",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8301",
  "quick-fetch": "/quick-fetch/static-1.4270",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5127",
  "floating-ui": "/floating-ui/static-1.71",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2762",
  "framer-motion": "/framer-motion/static-1.87",
  "hs-story-utils": "/hs-story-utils/static-1.9967",
  "react-aria": "/react-aria/static-1.80",
  "react-create-root-preference": "/react-create-root-preference/static-1.125",
  "tanstack-table": "/tanstack-table/static-1.69",
  "trellis-assets": "/trellis-assets/static-1.3277",
  "ui-fonts": "/ui-fonts/static-1.1295",
  "HeadJS": "/HeadJS/static-2.839",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3696",
  "msw": "/msw/static-1.106",
  "msw-config": "/msw-config/static-1.46",
  "testing-library": "/testing-library/static-1.168",
  "hs-locale-management": "/hs-locale-management/static-1.446",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.238",
  "moment-timezone": "/moment-timezone/static-5.99",
  "jasmine": "/jasmine/static-4.4848",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6341",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5295",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20640",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19710",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11442",
  "crm-message-bus": "/crm-message-bus/static-1.44272",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13580",
  "customer-data-properties": "/customer-data-properties/static-1.53272",
  "growth-payments-core": "/growth-payments-core/static-1.26641",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9622",
  "usage-tracker": "/usage-tracker/static-1.7889",
  "usage-tracker-container": "/usage-tracker-container/static-1.7879",
  "sassPrefix": "/sassPrefix/static-1.430",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4193",
  "foundations-theming-base": "/foundations-theming-base/static-1.4031",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3529",
  "stylex": "/stylex/static-1.50",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.343",
  "hub-http-janus": "/hub-http-janus/static-1.923",
  "hubspotter-http": "/hubspotter-http/static-1.5013",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.623",
  "module-federation": "/module-federation/static-1.42",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.718",
  "quartz-auth": "/quartz-auth/static-1.1448",
  "quartz-head": "/quartz-head/static-1.1438",
  "quartz-test": "/quartz-test/static-1.1448",
  "trellis-components": "/trellis-components/static-1.3296",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5575",
  "csstype": "/csstype/static-1.50",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.245",
  "web-vitals": "/web-vitals/static-1.22",
  "immer": "/immer/static-1.107",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.619",
  "chirp-fetch": "/chirp-fetch/static-1.2443",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.5011",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5254",
  "sequences-lib": "/sequences-lib/static-1.8879",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5132",
  "FileManagerCore": "/FileManagerCore/static-1.40447",
  "FileManagerLib": "/FileManagerLib/static-1.40588",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5419",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "salesImages": "/salesImages/static-1.801",
  "timezone-utils": "/timezone-utils/static-2.5769",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10659",
  "react-dnd-compat": "/react-dnd-compat/static-1.5153",
  "stylex-utils": "/stylex-utils/static-1.194",
  "trellis-theming": "/trellis-theming/static-1.1588",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.86",
  "avatar-components": "/avatar-components/static-1.3031",
  "crm-command-handler-types": "/crm-command-handler-types/static-1.210",
  "hs-resources": "/hs-resources/static-1.739",
  "onboarding-scopes": "/onboarding-scopes/static-1.6995",
  "pulse": "/pulse/static-1.1215",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.802",
  "utility-belt": "/utility-belt/static-1.3078",
  "zustand": "/zustand/static-1.93",
  "batch-promise": "/batch-promise/static-1.2094",
  "customer-data-associations": "/customer-data-associations/static-1.7887",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8602",
  "customer-data-tracking": "/customer-data-tracking/static-1.7413",
  "framework-data-table": "/framework-data-table/static-2.12956",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.50239",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.24417",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8341",
  "ui-addon-opt": "/ui-addon-opt/static-4.8982",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10143",
  "customer-data-rte": "/customer-data-rte/static-1.34010",
  "cv-backend-services": "/cv-backend-services/static-1.1622",
  "file-manager-components": "/file-manager-components/static-1.24948",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3600",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6636",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19415",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15969",
  "payment-link-components": "/payment-link-components/static-1.24600",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5641",
  "prosemirror": "/prosemirror/static-1.13",
  "qrcode-generator": "/qrcode-generator/static-1.83",
  "quotes-client-types": "/quotes-client-types/static-1.39305",
  "react-colorpicker": "/react-colorpicker/static-2.10753",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18615",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9165",
  "user-context": "/user-context/static-1.5598",
  "atom": "/atom/static-1.5616",
  "reference-resolvers": "/reference-resolvers/static-1.8729",
  "calling-global-api": "/calling-global-api/static-1.66542",
  "calling-internal-common": "/calling-internal-common/static-1.31866",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67924",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.60216",
  "commerce-products-lib": "/commerce-products-lib/static-1.11112",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4154",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4855",
  "crm-links": "/crm-links/static-1.6870",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4487",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10341",
  "data-agent-utils": "/data-agent-utils/static-1.1076",
  "data-token-picker": "/data-token-picker/static-1.17232",
  "external-options-client-types": "/external-options-client-types/static-1.4478",
  "formula-editor": "/formula-editor/static-1.15090",
  "google-libphonenumber": "/google-libphonenumber/static-1.53",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3813",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4557",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1178",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4052",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4325",
  "property-value-citations": "/property-value-citations/static-1.3886",
  "react-tinymce": "/react-tinymce/static-1.56387",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8656",
  "rich-text-lib": "/rich-text-lib/static-1.20655",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.624",
  "tiered-pricing": "/tiered-pricing/static-1.2394",
  "tinymce-config": "/tinymce-config/static-2.55513",
  "tinymce-plugins": "/tinymce-plugins/static-1.58627",
  "tinymce-themes": "/tinymce-themes/static-1.57483",
  "topics-actions-lib": "/topics-actions-lib/static-1.736",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1488",
  "trial-components-library": "/trial-components-library/static-1.14492",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10408",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11356",
  "laboratory-lib": "/laboratory-lib/static-3.7692",
  "seat-types-lib": "/seat-types-lib/static-1.1186",
  "magpie-lib": "/magpie-lib/static-1.5966",
  "navigation-messaging": "/navigation-messaging/static-1.8667",
  "ts-schema": "/ts-schema/static-1.4437",
  "opentelemetry-web": "/opentelemetry-web/static-1.26",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.11014",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.11012",
  "base-ui": "/base-ui/static-1.32",
  "react-day-picker": "/react-day-picker/static-1.19",
  "tanstack-virtual": "/tanstack-virtual/static-1.46",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.80",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8736",
  "audio-components": "/audio-components/static-1.6660",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.1234",
  "ContentUtils": "/ContentUtils/static-1.69631",
  "copilot-toolkit": "/copilot-toolkit/static-1.12279",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.30157",
  "FileManagerImages": "/FileManagerImages/static-1.38099",
  "html-to-image": "/html-to-image/static-1.70",
  "immerable": "/immerable/static-1.4687",
  "ui-universal-auth": "/ui-universal-auth/static-1.9874",
  "urlinator": "/urlinator/static-1.5060",
  "video-components": "/video-components/static-1.14568",
  "video-data-lib": "/video-data-lib/static-1.36224",
  "video-embed": "/video-embed/static-1.37058",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.878",
  "trellis-migration-context": "/trellis-migration-context/static-1.121",
  "event-emitter": "/event-emitter/static-1.1500",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.557",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4374",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.718",
  "fast-json-patch": "/fast-json-patch/static-1.79",
  "merchandise-lib": "/merchandise-lib/static-1.291",
  "purchase-motions-components": "/purchase-motions-components/static-1.6727",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13720",
  "reporting-data": "/reporting-data/static-1.69661",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.575",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7128",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5626",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19702",
  "onboarding-tours": "/onboarding-tours/static-1.17491",
  "stripe-connect-js": "/stripe-connect-js/static-1.86",
  "chatspot-core": "/chatspot-core/static-1.24317",
  "content-assistance-lib": "/content-assistance-lib/static-1.8511",
  "draft-content-plugins": "/draft-content-plugins/static-1.29263",
  "draft-convert": "/draft-convert/static-2.88",
  "draft-extend": "/draft-extend/static-3.91",
  "draft-js": "/draft-js/static-5.93",
  "draft-plugins": "/draft-plugins/static-2.22460",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2405",
  "poll-commands": "/poll-commands/static-1.4018",
  "video-components-external": "/video-components-external/static-1.12566",
  "trellis-story-utils": "/trellis-story-utils/static-1.5039",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.10072",
  "content-media-capture": "/content-media-capture/static-1.5900",
  "knowledge-content-types": "/knowledge-content-types/static-1.8767",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9640",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10830",
  "hub-http-contrib": "/hub-http-contrib/static-1.3573",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5750",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6957",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19676",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.4062",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18794",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1558",
  "calling-error-reporting": "/calling-error-reporting/static-1.31873",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11583",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.7084",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7657",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2626",
  "commerce-permissions": "/commerce-permissions/static-1.1323",
  "products-iframe-lib": "/products-iframe-lib/static-1.9068",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11396",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6993",
  "sales-views-client-types": "/sales-views-client-types/static-1.4801",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10565",
  "data-agent-kit": "/data-agent-kit/static-1.1063",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.423",
  "fsm": "/fsm/static-1.4304",
  "markdown-it": "/markdown-it/static-1.6",
  "policy-lib": "/policy-lib/static-1.7344",
  "bark-lib": "/bark-lib/static-1.17077",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.109",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6440",
  "react-codemirror": "/react-codemirror/static-1.11184",
  "tinymce": "/tinymce/static-5.11",
  "interframe": "/interframe/static-3.5288",
  "tinymce-data": "/tinymce-data/static-1.41598",
  "layout-dnd-components": "/layout-dnd-components/static-1.13328",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12303",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.17112",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9411",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.16243",
  "hubs-service-types": "/hubs-service-types/static-1.1809",
  "navigation-components": "/navigation-components/static-1.19340",
  "nest": "/nest/static-1.782",
  "nudge-client-utils": "/nudge-client-utils/static-1.3520",
  "purchase-motions-api": "/purchase-motions-api/static-1.6730",
  "signup-constants": "/signup-constants/static-1.20127",
  "idb-keyval": "/idb-keyval/static-1.59",
  "magpie-types": "/magpie-types/static-1.5426",
  "reactive-lib": "/reactive-lib/static-1.1265",
  "simple-logging-lib": "/simple-logging-lib/static-1.3590",
  "nav-meta": "/nav-meta/static-1.30977",
  "breeze-engine-core": "/breeze-engine-core/static-1.1683",
  "cms-field-types": "/cms-field-types/static-1.5356",
  "content-icons-ui": "/content-icons-ui/static-1.2526",
  "integrations-lib": "/integrations-lib/static-1.17574",
  "underscore": "/underscore/static-1.8",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.438",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1670",
  "social-insights-client-types": "/social-insights-client-types/static-1.23057",
  "outpost": "/outpost/static-1.4668",
  "persist-promise": "/persist-promise/static-1.4251",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8578",
  "reporting-client-types": "/reporting-client-types/static-1.2905",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.11089",
  "immutable-less": "/immutable-less/static-1.5191",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18577",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.21170",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8492",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4461",
  "growth-data-modal": "/growth-data-modal/static-1.6226",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.3113",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5706",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8211",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29646",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1383",
  "highlight.js": "/highlight.js/static-1.93",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13704",
  "content-media-compositions": "/content-media-compositions/static-2.17711",
  "media-bridge-lib": "/media-bridge-lib/static-1.19738",
  "fix-webm-duration": "/fix-webm-duration/static-1.38",
  "notification-sounds": "/notification-sounds/static-1.4972",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37403",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3897",
  "highcharts": "/highcharts/static-8.118",
  "storybook-react": "/storybook-react/static-1.47",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16786",
  "browser-eslint": "/browser-eslint/static-2.57",
  "ContentData": "/ContentData/static-1.69706",
  "layout-data-lib": "/layout-data-lib/static-1.10628",
  "academy-common-lib": "/academy-common-lib/static-1.15704",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3277",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3596",
  "whisper-core-api": "/whisper-core-api/static-1.7753",
  "flux-actions": "/flux-actions/static-1.384",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14989",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6171",
  "redux-observable": "/redux-observable/static-1.82",
  "rxjs": "/rxjs/static-5.10",
  "apps-service-types": "/apps-service-types/static-1.4151",
  "oauth-service-types": "/oauth-service-types/static-1.4679",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8694",
  "react-window": "/react-window/static-1.13",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1827",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2930",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3141",
  "user-context-client": "/user-context-client/static-1.5051",
  "js-cookie": "/js-cookie/static-1.18",
  "advanced-menus-core": "/advanced-menus-core/static-1.15917",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12644",
  "ExportDialog": "/ExportDialog/static-6.10915",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35343",
  "academy-service-client": "/academy-service-client/static-1.4236",
  "croppie": "/croppie/static-2.10",
  "final-form": "/final-form/static-1.86",
  "SafeStorage": "/SafeStorage/static-1.4938",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7947",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3563",
  "settings-ui-lib": "/settings-ui-lib/static-1.13076",
  "simple-data-table": "/simple-data-table/static-1.3952",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8162",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15916",
  "simple-menus-lib": "/simple-menus-lib/static-1.17433",
  "crm-record-cards-client": "/crm-record-cards-client/static-1.246",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7432",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7337"
}
};
